import { render, staticRenderFns } from "./PatientPoll.vue?vue&type=template&id=a603e1a6&scoped=true"
import script from "./PatientPoll.vue?vue&type=script&lang=js"
export * from "./PatientPoll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a603e1a6",
  null
  
)

export default component.exports